export class ValidationError extends Error {
    message: string;
    errors: ValidationErrorErrors;

    constructor(error) {
        super();
        Object.setPrototypeOf(this, ValidationError.prototype);

        this.message = 'Onbekend';
        this.errors = {};

        if (error) {
            if (error.message) {
                this.message = error.message;
            }
            if (error.errors) {
                this.errors = error.errors;
            }
        }
    }
}

export interface ValidationErrorErrors {
    [key: string]: string[]
}